
import { mixins, Options } from 'vue-class-component';
import { BaseWidgets, DataWidgetName, isRecognisedWidgetName } from '@/exported';
import { MCartWidgetPropProvider } from './MCartWidgetProps';
import MAddToCart from './widget/MAddToCart.vue';

@Options({
  components: {
    MAddToCart
  }
})
export default class MCartWrapper extends mixins(MCartWidgetPropProvider) {
  parentDataWidgetName: DataWidgetName | null = null;
  mounted(): void {
    const widgetName = this.$el?.parentElement?.getAttribute('data-widget') || '';
    if (!widgetName || !isRecognisedWidgetName(widgetName)) {
      this.parentDataWidgetName = null;
    }
    this.parentDataWidgetName = widgetName;
  }

  get dynamicComponent() {
    if (!this.parentDataWidgetName || !BaseWidgets[this.parentDataWidgetName]) {
      return null;
    }
    return BaseWidgets[this.parentDataWidgetName].component;
  }
}
